import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthHelperService} from '../../services/auth-helper.service';
import {RoleConstants} from '../../constants/roleConstants';
import {TenantService} from "../../services/tenant.service";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass'],
})
export class HomeComponent implements OnInit {
  constructor(private _router: Router,
              private _authHelper: AuthHelperService,
              private _tenantService: TenantService,
  ) {
  }

  ngOnInit() {
    this._tenantService.tenantId.subscribe(tenantId => {
      if (tenantId == null) {
        return;
      }

      if (this._authHelper.hasRole([RoleConstants.Admin, RoleConstants.TenantAdmin])) {
        this._router.navigate(['users']);
      } else if (this._authHelper.hasRole(RoleConstants.Clerk)) {
        this._router.navigate(['exam-reports']);
      }
    });
  }
}
